/** @deprecated Import from ./block-seeds.js — kept for backwards compatibility */
export { CARD_BLOCK_DEFAULTS } from './block-seeds'
